<template>
  <v-card tile v-if="items.length">
    <v-card-title class="pl-0">
      <v-icon color="cyan" class="mdi-rotate-90" large>mdi-window-minimize</v-icon>工单详情: {{items[0].title}}
    </v-card-title>
    <v-card-text>
      <v-timeline>
        <v-timeline-item v-for="item in items" :key="item.id" :left="item.dir==-1" :right="item.dir==1">
          <v-card>
            <v-card-title>{{Utility.fmtDt(item.ct)}}</v-card-title>
            <v-card-text>
              {{item.content}}
            </v-card-text>
          </v-card>
        </v-timeline-item>
        <v-timeline-item right>
          <v-card>
            <v-card-text>
              <v-textarea v-model="content" outlined dense placeholder="请填写您的描述内容" single-line hide-details></v-textarea>
              <v-btn color="primary" class="mt-2" block v-one-click @click="onReplyQa">提交</v-btn>
            </v-card-text>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>
<script>
import { userQaDetail, userQaAdd } from '@/plugins/api';
export default {
  data () {
    return {
      id: null,
      items: [],
      content: null
    }
  },
  created () {
    this.id = this.$route.params.id
    this.dataQuery()
  },
  methods: {
    dataQuery () {
      userQaDetail(this.id).then(res => this.items = res.data)
    },
    onReplyQa () {
      let dto = { title: this.items[0].title, content: this.content, pid: this.id }
      userQaAdd(dto).then(() => {
        this.$message.success('提交成功,已通知管理员,请耐心等待')
        this.content = null
        this.dataQuery()
      })
    }
  }
}
</script>